import { defineStore } from 'pinia';
import axiosAPIStore from './axiosAPI';
import axios from 'axios';

export default defineStore('searchComponent Store', {
  state: () => ({
    filterData: { value: '', funName: '' },
    searchData: '',
    loading: false,
    showCardData: [],
    userFavoriteXObject: [],
    searchMode: "queryByKeyword",
    showNoDataText: false,
    addObjectListData: [],
    searchKeyWords: "",
  }),
  actions: {
    // 標記常用(愛心)元件
    markCommonComponents() {
      if (!this.userFavoriteXObject || this.userFavoriteXObject.length === 0) return;
      if (!this.showCardData || this.showCardData.length === 0) return;

      const sortOutFavoriteXObject = this.userFavoriteXObject.map((item) => {
        const splitItem = item.split("_");

        return {
          organizationId: parseInt(splitItem[0]),
          xObjectId: `${splitItem[1]}_${splitItem[2]}`,
        };
      });

      this.showCardData.forEach((item) => {
        const judge = sortOutFavoriteXObject.some(
          (t) => t.xObjectId === item.xObjectId && t.organizationId === item.organizationId
        );

        item.IsStar = judge;
      });
    }
  }
})